/**
 * Quantity Gauge - quantity-gauge.js
 *
 * Pilote un <input type="range"> a paliers non lineaires (un palier =
 * une variante Shopify) relie a un champ de saisie numerique (les deux
 * sont synchronises dans les deux sens). Met a jour la case "avantages
 * / prix" (economie active en texte inline, statut de personnalisation
 * en pastille, empiles l'un sous l'autre) et synchronise le
 * variant-selects cache inclus dans le snippet pour declencher la
 * mise a jour native du theme (prix, bouton Ajouter au panier, url,
 * etc.), exactement comme le fait pack-picker.js pour le carousel de
 * cards.
 *
 * L'economie est affichee en pourcentage du prix barre. Sous la jauge,
 * une incitation propose de passer au palier data-nudge-qty (3000)
 * quand il coute moins cher (ou autant) au total que la quantite
 * choisie (effet de palier).
 *
 * Textes : window.C2V_I18N (snippet c2v-i18n.liquid, cles c2v.gauge.*),
 * sinon le francais du code. Quantites au format de la langue de la page
 * (window.C2V_LOCALE) ; montants au format monetaire de la boutique.
 */

(function () {
  'use strict';

  /* Doit correspondre a --qg-thumb dans component-quantity-gauge.css */
  var THUMB_SIZE = 22;

  /* ------------------------------------------------------------------ */
  /* Textes traduits (cles c2v.*), sinon le francais passe en argument  */
  /* ------------------------------------------------------------------ */

  var HTML_ENT = { amp: '&', lt: '<', gt: '>', quot: '"', '#39': "'", '#x27': "'", '#039': "'" };

  function T(key, fr, vars) {
    var d = window.C2V_I18N;
    var v = d && d[key];
    /* le filtre t de Shopify echappe le HTML des cles sans _html : on remet les caracteres d'origine */
    var s = typeof v === 'string' && v && !/^translation missing/i.test(v)
      ? v.replace(/&(amp|lt|gt|quot|#39|#x27|#039);/g, function (m, e) { return HTML_ENT[e]; })
      : fr;
    if (vars) {
      s = s.replace(/\{(\w+)\}/g, function (m, n) {
        return Object.prototype.hasOwnProperty.call(vars, n) ? String(vars[n]) : m;
      });
    }
    return s;
  }

  /* Langue de la page : fr-FR en francais (comme avant), en-GB pour l'anglais */
  var LOCALE = String(window.C2V_LOCALE || 'fr');
  var INTL = LOCALE.split('-')[0].toLowerCase() === 'fr' ? 'fr-FR' : LOCALE.toLowerCase() === 'en' ? 'en-GB' : LOCALE;

  /* ------------------------------------------------------------------ */
  /* Formatage monétaire (utilise window.Shopify.money_format si dispo) */
  /* ------------------------------------------------------------------ */

  function formatMoneyCents(cents) {
    var fmt = (window.Shopify && Shopify.money_format) || '{{amount}} €';
    var amount = (cents / 100).toFixed(2);
    var amountComma = amount.replace('.', ',');
    var noDecimals = String(Math.round(cents / 100));
    return fmt
      .replace('{{amount_with_comma_separator}}', amountComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', noDecimals)
      .replace('{{amount_no_decimals}}', noDecimals)
      .replace('{{amount}}', amount);
  }

  function formatQty(qty) {
    try {
      return qty.toLocaleString(INTL);
    } catch (e) {
      return String(qty);
    }
  }

  /**
   * Coche le bon radio dans le variant-selects cache, puis dispatche
   * un event change pour declencher la logique du theme.
   */
  function syncGaugeSelects(selectsEl, optionValue) {
    var fieldset = selectsEl.querySelector('fieldset');
    if (!fieldset) return;

    var radios = fieldset.querySelectorAll('input[type="radio"]');
    var target = null;
    radios.forEach(function (radio) {
      if (radio.value === optionValue) target = radio;
    });
    // Valeurs avec unite ("50 paires", "100 tests") : on compare le nombre en tete
    if (!target) {
      var wanted = Number(optionValue);
      radios.forEach(function (radio) {
        if (!target && parseFloat(radio.value.replace(/[\s\u00a0\u202f]/g, '')) === wanted) target = radio;
      });
    }

    if (target && !target.checked) {
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function initGauge(root) {
    var input = root.querySelector('.quantity-gauge__input');
    var qtyInput = root.querySelector('.quantity-gauge__qty-input');
    var dataScript = root.querySelector('[data-quantity-gauge-steps]');
    if (!input || !dataScript) return;

    var steps;
    try {
      steps = JSON.parse(dataScript.textContent);
    } catch (e) {
      return;
    }
    if (!steps || !steps.length) return;

    var sectionId = root.dataset.section;
    var qtyChipValueEl = root.querySelector('.quantity-gauge__qty-chip-value');
    var priceTotalEl = root.querySelector('.quantity-gauge__price-total');
    var priceUnitEl = root.querySelector('.quantity-gauge__price-unit');
    var advantageBoxEl = root.querySelector('.quantity-gauge__advantage-inline');
    var advantageTextEl = root.querySelector('.quantity-gauge__advantage-text');
    var perkPillEl = root.querySelector('.quantity-gauge__perk-pill');
    var perkPillTextEl = perkPillEl ? perkPillEl.querySelector('.quantity-gauge__perk-pill-text') : null;
    var trackWrap = root.querySelector('.quantity-gauge__track-wrap');
    var nudgeEl = root.querySelector('[data-quantity-gauge-nudge]');
    var nudgeTextEl = nudgeEl ? nudgeEl.querySelector('.quantity-gauge__nudge-text') : null;
    var nudgeBtnEl = nudgeEl ? nudgeEl.querySelector('.quantity-gauge__nudge-btn') : null;
    var unitLabelEl = root.querySelector('.quantity-gauge__qty-chip-label');
    var unitLabel = unitLabelEl ? unitLabelEl.textContent.trim() : T('gauge.unit_label', 'unités');
    var nudgeQty = parseFloat(root.dataset.nudgeQty);
    var nudgeIndex = -1;
    if (!isNaN(nudgeQty)) {
      for (var n = 0; n < steps.length; n++) {
        if (steps[n].qty === nudgeQty) {
          nudgeIndex = n;
          break;
        }
      }
    }

    var lastIndex = -1;

    function nearestStepIndex(qty) {
      var best = 0;
      var bestDiff = Infinity;
      for (var i = 0; i < steps.length; i++) {
        var diff = Math.abs(steps[i].qty - qty);
        if (diff < bestDiff) {
          bestDiff = diff;
          best = i;
        }
      }
      return best;
    }

    /* Position du curseur en tenant compte de la largeur du pouce natif,
       pour que le degrade de remplissage colle exactement au pouce. */
    function setFill(index) {
      var frac = index / (steps.length - 1);
      input.style.setProperty(
        '--qg-fill',
        'calc(' + THUMB_SIZE / 2 + 'px + (100% - ' + THUMB_SIZE + 'px) * ' + frac + ')'
      );
    }

    function updatePerkPill(currentQty) {
      if (!perkPillEl) return;
      var t1 = parseFloat(perkPillEl.dataset.threshold1);
      var l1 = perkPillEl.dataset.label1 || T('gauge.milestone_1', 'Personnalisation possible (+20 centimes par unité)');
      var t2 = parseFloat(perkPillEl.dataset.threshold2);
      var l2 = perkPillEl.dataset.label2 || T('gauge.milestone_2', 'Personnalisation offerte');

      var visible = true;
      var free = false;
      var text = '';

      if (!isNaN(t2) && currentQty >= t2) {
        text = l2;
        free = true;
      } else if (!isNaN(t1) && currentQty >= t1) {
        text = l1;
      } else {
        visible = false;
      }

      perkPillEl.classList.toggle('quantity-gauge__perk-pill--visible', visible);
      perkPillEl.classList.toggle('quantity-gauge__perk-pill--free', free);
      if (visible && perkPillTextEl) perkPillTextEl.textContent = text;
    }

    /* Economie en % du prix barre (prix barre = prix + economie), arrondi
       a l'inferieur comme la pastille "Economisez X%" du theme */
    function updateAdvantage(step) {
      if (!advantageBoxEl) return;
      var compareCents = step.price_cents + step.savings_cents;
      var percent = step.savings_cents > 0 ? Math.floor((step.savings_cents * 100) / compareCents) : 0;
      var hasSavings = percent >= 1;
      advantageBoxEl.classList.toggle('quantity-gauge__advantage-inline--visible', hasSavings);
      if (hasSavings && advantageTextEl) {
        var template = root.dataset.savingsTemplate || T('gauge.savings', 'Vous économisez {amount}');
        advantageTextEl.textContent = template.replace('{amount}', percent + '\u00a0%');
      }
    }

    /* Effet de palier : le palier cible coute moins cher (ou autant) au
       total que la quantite choisie -> on propose d'y passer. */
    function updateNudge(index) {
      if (!nudgeEl || !nudgeTextEl) return;
      var step = steps[index];
      var target = nudgeIndex >= 0 ? steps[nudgeIndex] : null;
      if (!step || !target || step.qty >= target.qty || target.price_cents > step.price_cents) {
        nudgeEl.hidden = true;
        return;
      }

      var lessCents = step.price_cents - target.price_cents;
      var targetQty = formatQty(target.qty);
      var moreQty = formatQty(target.qty - step.qty);
      var strong = document.createElement('b');
      var rest;

      if (lessCents > 0) {
        strong.textContent = T('gauge.nudge_less', 'À {qty} {unit}, vous payez {amount} de moins', { qty: targetQty, unit: unitLabel, amount: formatMoneyCents(lessCents) });
        rest = ' ' + T('gauge.nudge_less_rest', 'tout en recevant {more} {unit} de plus.', { more: moreQty, unit: unitLabel });
      } else {
        strong.textContent = T('gauge.nudge_same', 'À {qty} {unit}, même prix total', { qty: targetQty, unit: unitLabel });
        rest = ' ' + T('gauge.nudge_same_rest', 'pour {more} {unit} de plus.', { more: moreQty, unit: unitLabel });
      }

      nudgeTextEl.textContent = '';
      nudgeTextEl.appendChild(strong);
      nudgeTextEl.appendChild(document.createTextNode(rest));
      if (nudgeBtnEl) nudgeBtnEl.textContent = T('gauge.nudge_go', 'Passer à {qty}', { qty: targetQty });
      nudgeEl.hidden = false;
    }

    function updateDisplay(index) {
      var step = steps[index];
      if (!step) return;

      var unitCents = step.price_cents / step.qty;
      var qtyFormatted = formatQty(step.qty);
      var unitLabel = (root.dataset.unitPriceLabel || T('gauge.unit_price', 'soit {amount} / unité')).replace(
        '{amount}',
        formatMoneyCents(unitCents)
      );

      if (qtyChipValueEl) qtyChipValueEl.textContent = qtyFormatted;
      if (priceTotalEl) priceTotalEl.textContent = step.price_formatted;
      if (priceUnitEl) priceUnitEl.textContent = unitLabel;
      if (qtyInput && document.activeElement !== qtyInput) {
        qtyInput.value = step.qty;
      }

      setFill(index);
      updatePerkPill(step.qty);
      updateAdvantage(step);
      updateNudge(index);

      input.setAttribute('aria-valuetext', qtyFormatted + ' — ' + step.price_formatted);

      lastIndex = index;
    }

    function selectIndex(index, sync) {
      index = Math.max(0, Math.min(steps.length - 1, index));
      input.value = index;
      updateDisplay(index);

      if (sync) {
        var selectsEl = document.getElementById('quantity-gauge-selects-' + sectionId);
        if (selectsEl) syncGaugeSelects(selectsEl, String(steps[index].qty));
      }
    }

    input.addEventListener('input', function () {
      var index = parseInt(input.value, 10);
      if (index === lastIndex) return;
      selectIndex(index, true);
    });

    if (nudgeBtnEl) {
      nudgeBtnEl.addEventListener('click', function () {
        if (nudgeIndex >= 0) selectIndex(nudgeIndex, true);
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        var typed = parseFloat(qtyInput.value);
        if (isNaN(typed)) {
          qtyInput.value = steps[lastIndex] ? steps[lastIndex].qty : steps[0].qty;
          return;
        }
        selectIndex(nearestStepIndex(typed), true);
      });

      qtyInput.addEventListener('keydown', function (evt) {
        if (evt.key === 'Enter') {
          evt.preventDefault();
          qtyInput.blur();
        }
      });
    }

    /* Position initiale : variante actuellement selectionnee */
    var initialIndex = 0;
    var selectedId = root.dataset.selectedVariantId;
    if (selectedId) {
      for (var i = 0; i < steps.length; i++) {
        if (String(steps[i].id) === String(selectedId)) {
          initialIndex = i;
          break;
        }
      }
    }
    input.min = 0;
    input.max = steps.length - 1;
    input.step = 1;
    selectIndex(initialIndex, false);

    if (trackWrap) trackWrap.classList.add('is-ready');
  }

  function initAll() {
    document.querySelectorAll('.quantity-gauge').forEach(initGauge);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-init apres rechargement AJAX de section (theme FoxTheme) */
  document.addEventListener('DOMContentLoaded', function () {
    if (window.FoxTheme && FoxTheme.pubsub) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.sectionRefreshed, initAll);
    }
  });

  /* Observer pour les jauges injectees dynamiquement (Quick View...) */
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('quantity-gauge')) {
            initGauge(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('.quantity-gauge').forEach(initGauge);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
